// extracted by mini-css-extract-plugin
export default {"title1":"IntroTitle_title1__go+q-","title2":"IntroTitle_title2__JYBBN"};